'use client';
import styled from 'styled-components';

export const ModalContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 343px;
  padding: ${props => props.theme.spacing(10, 0, 4, 0)};
  gap: ${props => props.theme.spacing(8)};
  @media ${props => props.theme.tablet} {
    max-width: 418px;
    padding: ${props => props.theme.spacing(8, 8, 8, 8)};
  }
`;

export const ModalHeading = styled.h3`
  ${props => props.theme.typography.heading3};
`;

export const ModalContent = styled.div`
  width: 100%;
`;

export const ModalContentBody = styled.p`
  ${props => props.theme.typography.body};
  margin-bottom: ${props => props.theme.spacing(8)};
`;
